import keys from './fi.json';

export default {
  locale: 'fi',
  messages: {
    ...keys,
    'RoundDateDisplay::format': `{ hasEnd, select,
      true {
        { preposition, select,
          at { at { end } }
          until { until { end } }
        }
      }
      other { { duration, plural,
          one { # päivässä }
          other { # päivässä }
        }
      }
    }`,
    statusvalue: `{ roundNumber, select,
      0 {
        { content, select,
          Preview { Esikatselu }
          Resolved { Ratkaistu }
          other { {content} }
        }
      }
      other {
        { roundType, select,
          sealed_bidding { Suljettu }
          open_bidding { Avoin }
          counteroffer_bidding { Vastatarjous }
          registration { Rekisteröinti }
          SealedBidding { Suljettu }
          OpenBidding { Avoin }
          CounterofferBidding { Vastatarjous }
          incremental_auction { Joustava }
          simple_offer { Digitaalinen ostotarjous }
        }
        kierros
        { roundNumber }
        { roundStatus, select,
          opened { avattu }
          started { alkoi }
          closed { päättyi }
          other { {roundStatus} }
        }
      }
    }`,
    'RoundInfo::label': `
      { type, select,
        sealed_bidding { Suljettu }
        open_bidding { Avoin }
        incremental_auction { Joustava }
        counteroffer_bidding { Vastatarjous }
        registration { Rekisteröinti }
        simple_offer { Digitaalinen ostotarjous }
      }
      kierros
      { number }
      { status, select,
        started { ei vielä avattu }
        opened
        {
          {
            durationType, select,
              fixed {
                { isPast, select,
                  false { päättyy {endDuration} kuluttua }
                  other { ohi }
                }
              }
              flexible { päättyy {durationInDays} päivän kuluttua }

          }
        }
        closed { päättyi { endText } }
        other { {status} }
      }
    `,
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/fi.js